<template>
    <div ref="document" class="popup_scan">
     
   
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-box">
          
          <div class="spinner"></div>

          <div class="loading-text">
            {{ loadingText }}
          </div>

          <div class="progress-bar">
            <div 
              class="progress-fill" 
              :style="{ width: loadingProgress + '%' }"
            ></div>
          </div>

          <div class="progress-percent">
            {{ loadingProgress }} %
          </div>

        </div>
      </div>
      <div id="container"></div>
    </div>
    

  </template>
  
  
  <script>
  import jQuery from 'jquery';
  import {APIRequest} from "@simb2s/senseye-sdk";

  import * as THREE from 'three';
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
  import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
  
  var camera, controls, scene, renderer, center;
  const MAX_SIDE_ROTATION = Math.PI / 2;
  const POINTCLOUD_RIGHT_ROTATION = Math.PI / 2;
  const POINTCLOUD_LEFT_ROTATION = Math.PI / 2;

  export default {
    components: {  },
    name: 'ScanCanvas',
    props:['scan'],
    data() {
      return {
        loadingProgress: 0,
        isLoading: true,
        loadingText: "Scan Loading...",
        scanDetail:null,
       
        center:null,
        camera:null,
        controls:null,
        scene:null, 
        renderer:null,
        container:null,
        geometry:null,
        geometry2:null,
        ptcloud_array:[],
        modelLoaded:false
      }
    },
    async mounted(){
  
      await this.getScanDetails()

      let coordinates=await APIRequest.get_request('api/scans/point-cloud/'+this.scan.id)
 

     const pointCloud = coordinates.data.pointCloud

    
      this.ptcloud_array = typeof pointCloud === 'string' ? pointCloud.split(/\r?\n/) : []

      this.container = document.getElementById("container");
      const scanUrl = 'https://rhino.visages.com/scans/proc/' + this.scan.id + '.fbx'
      const fileExists = await this.doesFileExist(scanUrl)
      if (fileExists) {
        this.init()
      } else {
        this.init2(scanUrl, false)
      }
     
    },
    beforeUnmount() {
          window.removeEventListener('resize', this.onWindowResize);
    },
    methods:{
      displayMeasurements() {
        this.$emit('displayMeasurementsEv')
      },
      closeModal($event)
          {
              
              if(jQuery($event.target).parents('.conent').length)
              {
                
              }
              else
              {
                emitter.emit('hide-popup-scan')
                  $event.preventDefault()
              }
              
          },
     
      async getScanDetails() {
        this.scanDetail=this.scan
     
      },
      async doesFileExist(url, timeoutMs = 4000) {
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), timeoutMs)
        try {
          const response = await fetch(url, { method: 'HEAD', signal: controller.signal })
          return response.ok
        } catch (e) {
          return false
        } finally {
          clearTimeout(timeoutId)
        }
      },
      init() {
        renderer = new THREE.WebGLRenderer( { antialias: true } );
          
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( this.container.offsetWidth, this.container.offsetHeight );
        this.container.appendChild( renderer.domElement );
        scene = new THREE.Scene();
        scene.background = new THREE.Color( 0xffffff );
        camera = new THREE.PerspectiveCamera( 35, this.container.offsetWidth / this.container.offsetHeight, 0.1, 5000 );

        if(this.view=='front')
        {
            camera.position.x = 1.5;
            camera.position.z = 0;
        }
        else
        {
            camera.position.x = 0;
            camera.position.z = 1.5;
        }
        
        camera.position.y = 0;
        scene.add( camera );
  
        controls = new OrbitControls( camera, renderer.domElement );
        
        // Limit horizontal rotation to 180deg total (-90deg to +90deg).
        controls.minAzimuthAngle = -MAX_SIDE_ROTATION;
        controls.maxAzimuthAngle = MAX_SIDE_ROTATION;

        const ambientLight = new THREE.AmbientLight(0xffffff, 0.2)
        scene.add(ambientLight)
        const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.3)
        scene.add(hemiLight)
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
        scene.add(directionalLight)

        let scanUrl='https://rhino.visages.com/scans/proc/'+this.scan.id+".fbx"
        //let scanUrl='/assets/35.fbx'

        const loader = new FBXLoader()
        if (loader.setCrossOrigin) loader.setCrossOrigin('anonymous')
        let fakeProgressInterval = null;
        loader.load(
          scanUrl,
          (object) => {
          clearInterval(fakeProgressInterval)

          this.loadingProgress = 100
          this.loadingText = "Finalisation..."

          setTimeout(() => {
            this.isLoading = false
          }, 300)
          object.scale.setScalar(0.01)
          // Rotate so the model's front faces the camera instead of top-down
          object.rotation.x = -Math.PI / 2
          scene.add(object)

          // Force all mesh materials to pure white
          object.traverse((child) => {
            if (child.isMesh && child.material) {
              const toWhite = (mat) => {
                const params = {
                  color: 0xffffff,
                  metalness: 0.0,
                  roughness: 0.85,
                  side: mat.side !== undefined ? mat.side : THREE.FrontSide,
                  transparent: mat.transparent === true,
                  opacity: mat.opacity !== undefined ? mat.opacity : 1,
                  skinning: mat.skinning === true,
                  morphTargets: mat.morphTargets === true,
                  morphNormals: mat.morphNormals === true,
                }
                const newMat = new THREE.MeshStandardMaterial(params)
                newMat.needsUpdate = true
                return newMat
              }

              if (Array.isArray(child.material)) {
                child.material = child.material.map((m) => toWhite(m))
              } else {
                child.material = toWhite(child.material)
              }
            }
          })

          // Recompute bounds after rotation
          const box = new THREE.Box3().setFromObject(object)
          const centerVec = box.getCenter(new THREE.Vector3())
          const sizeVec = box.getSize(new THREE.Vector3())
          const maxDim = Math.max(sizeVec.x, sizeVec.y, sizeVec.z)
          const fov = camera.fov * (Math.PI / 180)
          let cameraZ = Math.abs(maxDim / (2 * Math.tan(fov / 2)))
          cameraZ *= 1.5

          camera.near = Math.max(0.1, cameraZ / 100)
          camera.far = cameraZ * 100
          camera.updateProjectionMatrix()

          camera.position.set(centerVec.x, centerVec.y, centerVec.z + cameraZ)
          camera.lookAt(centerVec)
          controls.target.copy(centerVec)
          controls.update()

          // Position the key light in front of the model and aim it at the center
          directionalLight.position.set(centerVec.x + cameraZ * 0.3, centerVec.y + cameraZ * 0.2, centerVec.z + cameraZ)
          directionalLight.target.position.copy(centerVec)
          scene.add(directionalLight.target)

          this.modelLoaded = true
          this.animate()
        },
        (xhr) => {
              if (xhr.lengthComputable && xhr.total > 0) {
                this.loadingProgress = Math.round((xhr.loaded / xhr.total) * 100)
              } else {
                // simulate smooth progress si pas de total
                if (!fakeProgressInterval) {
                  fakeProgressInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                      this.loadingProgress += 0.5
                    }
                  }, 100)
                }
              }
            },

            (error) => {
              clearInterval(fakeProgressInterval);

              this.isLoading = false
              console.error("Erreur FBX :", error)

              this.loadingText = "Erreur de chargement..."
              
              setTimeout(() => {
                this.isLoading = false
                this.init2(scanUrl, false) // fallback pointcloud
              }, 800)
            }
          )

        window.addEventListener( 'resize', this.onWindowResize, false );
      },
      init2(scanUrl, fileExists) {
        if (fileExists) return

        this.loadingProgress = 100
        this.isLoading = false
        this.loadingText = "Pointcloud"

        renderer = new THREE.WebGLRenderer( { antialias: true } )
        renderer.setPixelRatio( window.devicePixelRatio )
        renderer.setSize( this.container.offsetWidth, this.container.offsetHeight )
        this.container.innerHTML = ''
        this.container.appendChild( renderer.domElement )

        scene = new THREE.Scene()
        scene.background = new THREE.Color( 0xffffff )
        camera = new THREE.PerspectiveCamera( 15, this.container.offsetWidth / this.container.offsetHeight, 0.01, 40 )
        camera.position.x = -1.5
        camera.position.z = 0
        camera.position.y = 0
        scene.add( camera )

        controls = new OrbitControls( camera, renderer.domElement )

        const geometry = new THREE.BufferGeometry()
        const points_array = []
        const colors_array = []

        for (let i = 0; i < this.ptcloud_array.length; i++) {
          const points_ex = this.ptcloud_array[i].split(',')
          if (points_ex.length < 6) continue
          points_array.push(points_ex[0], points_ex[1], points_ex[2])
          colors_array.push(points_ex[3], points_ex[4], points_ex[5])
        }

        const points_vertices = new Float32Array(points_array)
        const colors = new Uint8Array(colors_array)
        geometry.setAttribute('position', new THREE.BufferAttribute(points_vertices, 3))
        geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))
        geometry.attributes.color.normalized = true

        const material = new THREE.PointsMaterial({ vertexColors: true, size: 0.0045 })
        const mesh = new THREE.Points(geometry, material)
        scene.add(mesh)

        mesh.geometry.computeBoundingSphere()
        if (mesh.geometry.boundingSphere != null) {
          center = mesh.geometry.boundingSphere.center.clone()
          center.x -= 0.03
        } else {
          center = new THREE.Vector3(0, 0, 0)
        }

        camera.lookAt(center)
        controls.target.copy(center)
        controls.update()

        const startAzimuth = controls.getAzimuthalAngle()
        controls.minAzimuthAngle = startAzimuth - POINTCLOUD_RIGHT_ROTATION
        controls.maxAzimuthAngle = startAzimuth + POINTCLOUD_LEFT_ROTATION

        mesh.rotation.y += 1.6
        this.modelLoaded = true
        this.animate()
      },
      onWindowResize() {
        camera.aspect = this.container.offsetWidth / this.container.offsetHeight;
        camera.updateProjectionMatrix();
       renderer.setSize( this.container.offsetWidth, this.container.offsetHeight );
        controls.handleResize();
      },
      
      animate() {
        requestAnimationFrame( this.animate );
        renderer.render( scene, camera );
      }
      
    },
  
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
   .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(241, 241, 241, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.loading-box {
  width: 250px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top: 4px solid #555;
  border-radius: 50%;
  margin: 0 auto 15px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #4caf50;
  width: 0%;
  transition: width 0.2s ease;
}

.progress-percent {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}
  .measurements-button
  {
    position:absolute;
    bottom:20px;
    left:20px;
    display:flex;
    background:#fff;
    font-size:12px;
    cursor:pointer;
    padding:5px 10px;
    border-radius: 5px;
    align-items:center;
    justify-content:flex-start;
    gap:10px;
  }
  .initiales
  {
    background:#fff;
    padding:5px 12px;
    color:#999;
    border-radius: 5px;
  }
  .button-scan
  {
    width:calc(100% - 20px);
    position:absolute;
    top:20px;
    left:20px;
  
    display:flex;
    align-items:center;
    justify-content:flex-start;
    gap:15px;
  }
    #container {
      background:#ffffff;
      display:block;
      width:100%;
      border-radius: 5px;
      height:45vw;
      max-height: 490px;
    }
    .popup_scan {
      position:relative;
      top:0;
      left:0;
      width:100%;
      
      border-radius: 5px;
    height: 100%;
    overflow: hidden;
        
     display:block;
    }

    @media (orientation: landscape) {
      #container {
 
      height:30vw !important;
     
    }
    }
  </style>
  